import React from "react";
import { createContext, useContext, useMemo, useReducer } from "react";
import Dialog from "./Dialog";

export const DialogTypes = Object.freeze({
  CLOSE: "close",
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
});

const defaultState = {
  success: false,
  error: false,
  open: false,
  onClose: () => {},
  title: "Title",
  content: "Content",
  onClickPrimary: () => {},
  onClickSecondary: () => {},
  primaryText: "OK",
  secondaryText: "Cancel",
};

const DialogReducer = (state = defaultState, { type, payload }) => {
  switch (type) {
    case DialogTypes.CLOSE:
      return {
        ...state,
        open: false,
      };
    case DialogTypes.ERROR:
      return {
        ...payload,
        error: true,
        open: true,
      };
    case DialogTypes.SUCCESS:
      return {
        ...payload,
        success: true,
        open: true,
      };
    case DialogTypes.INFO:
      return state;
    case DialogTypes.WARNING:
      return {
        ...payload,
        error: true,
        open: true,
      };
    default:
      return state;
  }
};

const DialogContext = createContext(defaultState);
const DialogDispatch = createContext(() => {});

export const useDialogContext = () => useContext(DialogContext);
export const useDialogDispatch = () => useContext(DialogDispatch);

export const DialogProvider = ({ children }) => {
  const [state, dispatch] = useReducer(DialogReducer, defaultState);

  const transFormState = useMemo(
    () => ({
      ...state,
      onClose: () =>
        dispatch({ type: DialogTypes.CLOSE, payload: { ...state } }),
      onClickSecondary: () =>
        dispatch({ type: DialogTypes.CLOSE, payload: { ...state } }),
    }),
    [state]
  );

  return (
    <DialogContext.Provider value={transFormState}>
      <DialogDispatch.Provider value={dispatch}>
        {children}
      </DialogDispatch.Provider>
    </DialogContext.Provider>
  );
};

export const DialogConsumer = () => {
  const dialog = useDialogContext();
  return <Dialog {...dialog} />;
};
